angular.module('impactx.ruleset').controller('RuleUserInvoiceCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'RuleUserService',
    'TranslationService',
    'ToolbarService',
    RuleUserInvoiceCtrl]);

function RuleUserInvoiceCtrl($scope, dataGen, $routeParams, RuleUserService, TranslationService, ToolbarService) {
    var self = this;

    dataGen.getData($scope, {ateId: $routeParams.ATEId, atpId: $routeParams.ATPId}, '/ruleuser/invoice/view')
        .then(function () {
            $scope.trns.delete = TranslationService.get('delete');
            $scope.trns.save = TranslationService.get('save');

            defineButtons();
        });

    self.saveRuleUser = function () {
        return RuleUserService.saveRuleUser($scope);
    };

    self.deleteRuleUser = function () {
        return RuleUserService.deleteRuleUser($scope);
    };

    self.toggleRuleUserType = function (ruleType) {
        RuleUserService.toggleRuleUserType($scope, ruleType);
    };

    self.hasNoSelectedApprover = function () {
        return RuleUserService.hasNoSelectedApprover($scope);
    };

    self.clearChangeType = function (notificationEnabled, modificationEnabled) {
        RuleUserService.clearChangeType($scope, notificationEnabled, modificationEnabled)
    };

    self.setUsers = function (selected) {
        if (selected) {
            $scope.data.users.selected = selected;
            self.toggleRuleUserType();
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveRuleUser,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {valueFunction: disableSave, error: $scope.trns.selectOneApprover}
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteRuleUser,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function disableSave() {
        return self.hasNoSelectedApprover();
    }

    function canDelete() {
        return $scope.data.id > 0;
    }
}